import { useEffect, useRef } from "react";
import { getCloudinaryRawUrl, isEmpty } from "@swiggy-private/js-utils";
import { IDineoutCartResponseData } from "@swiggy-private/checkout-types";

const DINE_CASH_LOTTIE_IDS = [
    "portal/static-assets/lotties/dinecash_pooling/initialLandingLottie.json",
    "portal/static-assets/lotties/dinecash_pooling/Amount_Recevied.json",
    "portal/static-assets/lotties/dinecash_pooling/ledgerMaxReached.json",
];

export const usePrefetchDineCashPollingLottie = (reviewedCart?: IDineoutCartResponseData | null) => {
    const fetchedRef = useRef(false);
    useEffect(() => {
        if (isEmpty(reviewedCart?.rewardsPoolWidget) || fetchedRef.current) return;
        DINE_CASH_LOTTIE_IDS.forEach((id) => {
            fetch(getCloudinaryRawUrl(id) || "").catch(() => void 0);
        });
        fetchedRef.current = true;
    }, [reviewedCart?.rewardsPoolWidget]);
};
